export enum ScheduleType {
  FULL_TIME = 'Full Time',
  PART_TIME = 'Part Time',
  FLEXIBLE = 'Flexible',
}
